module.exports = __webpack_public_path__ + "static/img/c4.cfff25b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/c4.png
// module id = Xf/f
// module chunks = 0